import React, {useEffect} from 'react';
import {useTeams} from 'data/team';
import {UsersRound} from 'lucide-react';

const TeamPicker = ({teamId, onTeamIdChange}) => {
	const {data: teamsData} = useTeams({
		params: {
			getAllTeams: false,
			type: 'sales',
		},
	});

	useEffect(() => {
		if (!teamId && teamsData?.length) {
			onTeamIdChange(teamsData[0]?.id);
		}
	}, [teamsData, onTeamIdChange, teamId]);

	return (
		<div className="flex gap-3 items-center">
			<UsersRound className="size-5 text-gray-400" />
			<select
				value={teamId || ''}
				onChange={e => onTeamIdChange(e.target.value || null)}
				className="border rounded-md h-8 px-2 font-medium shadow-sm"
			>
				<option value="">-</option>
				{(teamsData || []).map(team => (
					<option key={team.id} value={team.id}>
						{team.title}
					</option>
				))}
			</select>
		</div>
	);
};

export default TeamPicker;
